import { ReactNode } from "react";
import { EntryLineRow, UserFullRow } from "namirasoft-password";
import { BaseColumnFormatter, NSCopy, TableColumnInfo, TableRowInfo } from "namirasoft-site-react";
import { PasswordFormatter } from "./PasswordFormatter";
import { PasswordRouterProps } from "../PasswordRouterProps";
import Styles from "./EntryLineFormatter.module.css";

export class EntryLineFormatter<RowType = any> extends BaseColumnFormatter
{
    private password_formatter: PasswordFormatter<RowType>;

    constructor(public props: PasswordRouterProps & { user: UserFullRow }, width: string = "320px")
    {
        super();
        this.width = width;
        this.password_formatter = new PasswordFormatter(props, () => true, width);
    }

    override format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean): ReactNode
    {
        let lines: EntryLineRow[] = Array.isArray(value) ? value : (row?.value?.entry_line ?? []);
        if (lines.length === 0)
            return "";

        if (printable)
            return lines.map(line => `${line.name}: ${line.sensitive ? "********" : (line.value ?? "")}`).join("\n");

        return (
            <div className={Styles.ns_entry_lines_cell}>
                {
                    lines.sort((a, b) => a.order - b.order).map(line => (
                        <div key={line.id} className={Styles.ns_entry_line_row}>
                            <span className={Styles.ns_entry_line_name}>{line.name}:</span>
                            {
                                line.sensitive ?
                                    this.password_formatter.format(line.value, column, row, printable)
                                    :
                                    <NSCopy value={line.value ?? ""} classList={[Styles.ns_entry_line_copy]}>
                                        <span className={Styles.ns_entry_line_value}>
                                            {line.value ?? ""}
                                        </span>
                                    </NSCopy>
                            }
                        </div>
                    ))
                }
            </div>
        );
    }
}